import React from 'react'

const Dashboard = () => {
  return (
    <div>
        <div style={{
            display:"grid",
            gridTemplateColumns:"repeat(3,30%)",
            gap:"3%"

        }}>
            <div>hello</div>
            <div>world</div>
            <div>!</div>
        </div>
        <div>
            
        </div>
    </div>
  )
}

export default Dashboard